export const ENDPOINT_FAQ_FIND_ALL = '/api/faq/list';
export const ENDPOINT_FAQ_FIND_ONE = '/api/faq/get-one';
export const ENDPOINT_FAQ_CREATE_ONE = '/api/faq/create';
export const ENDPOINT_FAQ_DELETE_ONE = '/api/faq/delete';
export const ENDPOINT_FAQ_UPDATE_ONE = '/api/faq/update';
